import { TraitFillBlock } from "./TraitFillBlock";

export default TraitFillBlock;
